import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { URL_CONST } from 'utils/urlConsts'

import LoginFlow from 'containers/Login/LoginFlow'

import { LoginStyles } from 'components/styles/layouts/login.styles'

export default function Login() {
  return (
    <LoginStyles>
      <div className="hide-preloader-animated login">
        <div className="login-content">
          <img
            className="logo"
            src={`${STATIC_BASE_URL}/static/webapp/img/signin-ironscales-logo.svg`}
            alt="IRONSCALES"
          />
          <Switch>
            <Route path={URL_CONST.login.signin} exact component={LoginFlow} />
          </Switch>
        </div>
      </div>
    </LoginStyles>
  )
}
